import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useReportingHeaderConst } from "./ReportingHeaderConst";
import Table from "@/components/Table/table";
import { IconoirXmark } from "@ey-xd/motif-icon";

import {
  MotifButton,
  MotifErrorMessage,
  MotifFormField,
  MotifIcon,
  MotifOption,
  MotifProgressLoader,
  MotifSelect,
  MotifToast,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import "./Reporting.scss";
import { Controller, useForm } from "react-hook-form";
import {
  useGetPayeeMatchReportQuery,
  useDownloadDocumentReportMutation,
  useLazyDownloadGenerateDocumentQuery,
  useGetPaymentReportListQuery,
  useLazyDownloadGenerateDocumentWithOutExportQuery,
} from "./ReportingHelpers";
import { useCase } from "@/features/case/use-case";
import { useParams } from "react-router-dom";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import { useDispatch, useSelector } from "react-redux";
import { commonFormateName, getOnlyDate } from "@/utility/common";
import CustomPagination from "@/components/Pagination/CustomPagination";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import { GetCommonDownloadImgButton } from "@/components/Images/CommonImages";
const Reporting: React.FC = () => {
  const { t } = useTranslation();
  const { caseId } = useParams<{ caseId: string }>();
  const [downloadDocumentReport] = useDownloadDocumentReportMutation();
  let [documnetId, setDocumentId] = useState<string>("");
  const retainState = useSelector((e: any) => e.retainState.reportingTabState);
  const { caseShortName, abbreviation } = useSelector(
    (state: any) => state.case
  );

  const reportsData: any = {
    1: {
      url: "/Payment/ExportPaymentRegister",
      reportName: "pages.reporting.reportListLabels.paymentRegister",
    },
    3: {
      url: "/Report/ExportClaimsReport",
      reportName: "pages.reporting.reportListLabels.claimsReport",
    },
    4: {
      url: "/Creditor/ExportCreditorsByCase",
      reportName: "pages.reporting.fileName.creditor",
    },
    5: {
      url: "/Report/ExportContactReport",
      reportName: "pages.reporting.fileName.contacts",
    },
    6: {
      url: "/Report/ExportClaimItemReport",
      reportName: "pages.reporting.fileName.claimItem",
    },
  };

  let reportsList: any[] = [
    {
      reportName: "pages.reporting.reportListLabels.paymentRegister",
      reportId: "1",
    },
    {
      reportName: "pages.reporting.reportListLabels.paymentMatchReport",
      reportId: "2",
    },
    {
      reportName: "pages.reporting.reportListLabels.claimsReport",
      reportId: "3",
    },
    {
      reportName: "pages.reporting.reportListLabels.creditorReport",
      reportId: "4",
    },
    {
      reportName: "pages.reporting.reportListLabels.contactsreports",
      reportId: "5",
    },
    {
      reportName: "pages.reporting.reportListLabels.claimItemReport",
      reportId: "6",
    },
  ];
  let reportTypeList: any[] = [
    {
      reportTypeName: "pages.reporting.reportTypeListLabels.rbc",
      reportTypeId: "0",
    },
    {
      reportTypeName: "pages.reporting.reportTypeListLabels.desjardin",
      reportTypeId: "1",
    },
  ];
  const {
    control,
    formState: { errors },
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      reportId: retainState.reportId || "1",
      reportType: retainState.reportType || "0",
    },
  });
  const [reportType, reportId] = watch(["reportType", "reportId"]);

  const caseData = useCase();
  const columnDefs = useReportingHeaderConst(documnetId, reportId, reportType);

  let tableLoadingData = customTableLoadingData;
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  const [errorMessage, setErrorMessage] = useState("");
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      CaseId: caseId || caseData.caseId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize,
      SearchText: retainState?.SearchText || "",
      ReportType: retainState?.reportType,
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [retainState, caseId, caseData.caseId]);
  const paginationObj = getPaginationObj;
  // let {
  //   data: paymentRegister,
  //   error: paymentRegisterError,
  //   isFetching: paymentRegisterFetching,
  //   status: paymentRegisterStatus,
  // } = useGetReportsListQuery(
  //   { CaseId: caseData.caseId || caseId },
  //   { skip: true || (reportId !== "1" && paginationObj?.CaseId) }
  // );
  const dispatch = useDispatch();
  function handlePaginationData(data: any, columnTypesData: any) {
    setRefreshPaymentRegisterGrid(reportId === "1");

    dispatch(
      setComponentState1({
        entityName: "reportingTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  let resetSortStatus = (defaultSort: string) => {
    let json: any = { ...retainState.sortedColumnTypes };
    for (const key in json) {
      json[key] = { sort: null };
    }
    json[defaultSort] = { sort: "desc" };
    return json;
  };
  let {
    data: payeeMatchList,
    error: payeeFetchError,
    isFetching: payeeMatchFetching,
    status: payeeMatchStatus,
    // isLoading:payeeMatchLoading,
  } = useGetPayeeMatchReportQuery(paginationObj, {
    skip: !(paginationObj?.reportType !== "" && reportId === "2"),
  });

  const [generateReport, { isFetching: generateReportFetching }] =
    useLazyDownloadGenerateDocumentQuery();
  const [
    generateReportWithoutExport,
    { isFetching: generateReportFetchingWithoutExport },
  ] = useLazyDownloadGenerateDocumentWithOutExportQuery();
  const {
    data: paymentRegister,
    error: paymentRegisterError,
    isFetching: paymentRegisterFetching,
    isLoading: paymentRegisterLoading,
    status: paymentRegisterStatus,
    refetch: paymentRegisterReftech,
  } = useGetPaymentReportListQuery(paginationObj, { skip: reportId !== "1" });
  let interval = useRef<any>(null);
  let [refreshPaymentRegisterGrid, setRefreshPaymentRegisterGrid] =
    useState(false);
  let checkPaymentregisterStatus = useCallback(() => {
    let trigger = false;
    paymentRegister?.results?.find((item: any) => {
      if ([1, 2]?.includes(item.processingStatus)) {
        trigger = true;
        return true;
      }
      return false;
    });
    return trigger;
  }, [paymentRegister?.results]);
  useEffect(() => {
    if (reportId === "1" && checkPaymentregisterStatus()) {
      setRefreshPaymentRegisterGrid(false);

      interval.current = setInterval(() => {
        paymentRegisterReftech();
      }, 10000);
    } else {
      clearInterval(interval.current);
    }

    return () => clearInterval(interval.current);
  }, [
    reportId,
    paymentRegisterReftech,
    paymentRegisterFetching,
    checkPaymentregisterStatus,
  ]);
  const datePickerData = {
    FromDate: retainState?.FromDate || "",
    ToDate: retainState?.ToDate || "",
  };
  function generatePayment() {
    setErrorMessage("");
    let requestObj = {
      CaseId: caseId,
      Url: reportsData[reportId].url,
      fileName: abbreviation
        ? commonFormateName(
            caseShortName,
            t(reportsData[reportId].reportName),
            abbreviation
          )
        : "",
    };
    if (reportId === "1") {
      clearInterval(interval.current);
      let args = {
        FromDate: datePickerData?.FromDate
          ? `${getOnlyDate(datePickerData?.FromDate)} 00:00`
          : "",
        ToDate: datePickerData?.ToDate
          ? `${getOnlyDate(datePickerData?.ToDate)} 23:59`
          : "",
      };
      requestObj = { ...requestObj, ...args };
      setRefreshPaymentRegisterGrid(false);

      generateReportWithoutExport(requestObj)
        .then((response) => {
          dispatch(
            setComponentState1({
              entityName: "reportingTabState",
              entityState: {
                PageNumber: 1,
                PageSize: paginationPageSize,
                sortedColumnTypes: resetSortStatus("createdOnType"),
                SortOrder: "desc",
                SortColumn: "CreatedOn",
              },
            })
          );

          paymentRegisterReftech();
          if (response?.error && "data" in response.error) {
            try {
              const errObj = JSON.parse(response?.error?.data as string);
              window.scrollTo(0, 0);
              setErrorMessage(errObj?.message || errObj.title);
            } catch (error) {
              window.scrollTo(0, 0);
              setErrorMessage("Something went wrong!!");
            }
          }
        })
        .catch((error: any) => {
          window.scrollTo(0, 0);
          setErrorMessage("Something went wrong!!");
        });
      return;
    }
    generateReport(requestObj)
      .then((response) => {
        if (response?.error && "data" in response.error) {
          try {
            const errObj = JSON.parse(response?.error?.data as string);
            window.scrollTo(0, 0);
            setErrorMessage(errObj?.message || errObj.title);
          } catch (error) {
            window.scrollTo(0, 0);
            setErrorMessage("Something went wrong!!");
          }
        }
      })
      .catch((error: any) => {
        window.scrollTo(0, 0);
        setErrorMessage("Something went wrong!!");
      });
  }
  const customActionHeader = {
    paymentRegisterDownload: function (params: any) {
      return [0].includes(params.data.processingStatus) ? (
        <GetCommonDownloadImgButton
          loading={params?.selectedDoumnetId === params?.data?.documentId}
          onClick={() => {
            setDocumentId(params?.data?.documentId);
            downloadDocumentReport({
              caseId: caseId,
              documentId: params?.data?.documentId,
              fileName: params?.caseAbbrevation
                ? commonFormateName(
                    params?.caseShortName,
                    t("pages.reporting.reportListLabels.paymentRegister"),
                    params?.caseAbbrevation
                  )
                : "",
            })
              .then(() => {
                setDocumentId("");
              })
              .catch(() => {
                setDocumentId("");
              });
          }}
        ></GetCommonDownloadImgButton>
      ) : [1, 2].includes(params.data.processingStatus) ? (
        <MotifProgressLoader variant="circular" size="xs" />
      ) : (
        <></>
      );
    },
    payeeMatchReportDownload: function (params: any) {
      return (
        <GetCommonDownloadImgButton
          loading={params?.selectedDoumnetId === params?.data?.documentId}
          onClick={() => {
            setDocumentId(params?.data?.documentId);
            downloadDocumentReport({
              caseId: caseId,
              documentId: params?.data?.documentId,
              fileName: params?.data?.documentName || "",
            })
              .then(() => {
                setDocumentId("");
              })
              .catch(() => {
                setDocumentId("");
              });
          }}
        ></GetCommonDownloadImgButton>
      );
    },
  };
  const tableData =
    reportId === "1" ? paymentRegister?.results : payeeMatchList?.results;
  const hasMoreRecords =
    reportId === "1"
      ? paymentRegister?.hasMoreRecords
      : payeeMatchList?.hasMoreRecords;
  const apiRes = reportId === "1" ? paymentRegister : payeeMatchList;
  const apiStatus = reportId === "1" ? paymentRegisterStatus : payeeMatchStatus;
  const dataLoading =
    reportId === "1"
      ? paymentRegisterLoading ||
        (refreshPaymentRegisterGrid && paymentRegisterFetching)
      : payeeMatchFetching;
  const dataLoadingError =
    reportId === "1" ? paymentRegisterError : payeeFetchError;

  return (
    <div className="reporting-container">
      {errorMessage && (
        <MotifToast variant="error" onClose={() => setErrorMessage("")}>
          {t(errorMessage)}
        </MotifToast>
      )}
      {
        <div
          style={{ rowGap: "10px" }}
          className="motif-row align-items-center justify-content-start mar-t-10"
        >
          <div className="motif-col-md-2">
            <MotifFormField>
              <div className="formFieldLabel">
                <label>{t("pages.reporting.reportDropDownTitle")}</label>
              </div>
              <Controller
                control={control}
                rules={{
                  required: "pages.reporting.reportRequired",
                }}
                render={({ field: { onChange, value } }) => {
                  return (
                    <MotifSelect
                      placeholder={t("pages.reporting.selectReport")}
                      visibleOptions={5}
                      value={value}
                      onChange={(e) => {
                        setValue("reportType", "0");
                        dispatch(
                          setComponentState1({
                            entityName: "reportingTabState",
                            entityState: {
                              reportType: "0",
                              PageNumber: 1,
                              PageSize: paginationPageSize,
                              sortedColumnTypes:
                                resetSortStatus("createdOnType"),
                              reportId: e,
                              FromDate: "",
                              ToDate: "",
                              SortOrder: "desc",
                              SortColumn: "CreatedOn",
                            },
                          })
                        );
                        clearInterval(interval.current);
                        onChange(e);
                        setErrorMessage("");
                      }}
                      triggerButtonProps={{ type: "button" }}
                    >
                      {reportsList.map((option) => (
                        <MotifOption
                          key={option.reportId}
                          value={option.reportId}
                        >
                          {t(option.reportName)}
                        </MotifOption>
                      ))}
                    </MotifSelect>
                  );
                }}
                name="reportId"
              />
            </MotifFormField>
            {errors?.reportId && (
              <MotifErrorMessage>
                {t(`${errors.reportId.message}`)}
              </MotifErrorMessage>
            )}
          </div>
          {reportId === "2" && (
            <div className="motif-col-md-2">
              <MotifFormField>
                <div className="formFieldLabel">
                  <label>{t("pages.reporting.reportTypeDropDownTitle")}</label>
                </div>
                <Controller
                  control={control}
                  rules={{
                    required:
                      reportId === "2"
                        ? "pages.reporting.reportTypeRequired"
                        : false,
                  }}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <MotifSelect
                        placeholder={t("pages.reporting.selectReport")}
                        visibleOptions={3}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                          dispatch(
                            setComponentState1({
                              entityName: "reportingTabState",
                              entityState: {
                                reportType: e,
                                PageNumber: 1,
                                sortedColumnTypes:
                                  resetSortStatus("createdOnType"),
                                SortOrder: "desc",
                                SortColumn: "CreatedOn",
                              },
                            })
                          );
                        }}
                        triggerButtonProps={{ type: "button" }}
                      >
                        {reportTypeList.map((option) => (
                          <MotifOption
                            key={option.reportTypeId}
                            value={option.reportTypeId}
                          >
                            {t(option.reportTypeName)}
                          </MotifOption>
                        ))}
                      </MotifSelect>
                    );
                  }}
                  name="reportType"
                />
              </MotifFormField>
              {errors?.reportType && (
                <MotifErrorMessage>
                  {t(`${errors.reportType.message}`)}
                </MotifErrorMessage>
              )}
            </div>
          )}
          {["1"]?.includes(reportId) && (
            <div className="motif-col-lg-3">
              <div className="formFieldLabel">
                <label>{t("pages.reporting.paymentRegisterStartDate")}</label>
              </div>{" "}
              <MotifFormField>
                <div style={{ position: "relative" }}>
                  <FormattedDatePicker
                    onChange={(value) => {
                      dispatch(
                        setComponentState1({
                          entityName: "reportingTabState",
                          entityState: {
                            FromDate: value,
                          },
                        })
                      );
                    }}
                    required={true}
                    value={datePickerData?.FromDate}
                    range={false}
                    maxDate={
                      datePickerData.ToDate
                        ? new Date(datePickerData.ToDate)
                        : undefined
                    }
                  />
                  {datePickerData.FromDate && (
                    <div
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "11px",
                        right: "35px",
                      }}
                    >
                      <MotifIcon
                        size="24px"
                        onClick={() => {
                          dispatch(
                            setComponentState1({
                              entityName: "reportingTabState",
                              entityState: {
                                FromDate: "",
                              },
                            })
                          );
                        }}
                        src={IconoirXmark}
                      />
                    </div>
                  )}
                </div>
              </MotifFormField>
            </div>
          )}
          {["1"]?.includes(reportId) && (
            <div className="motif-col-lg-3">
              <div className="formFieldLabel">
                <label>{t("pages.reporting.paymentRegisterEndDate")}</label>
              </div>{" "}
              <MotifFormField>
                <div style={{ position: "relative" }}>
                  <FormattedDatePicker
                    onChange={(value) => {
                      dispatch(
                        setComponentState1({
                          entityName: "reportingTabState",
                          entityState: {
                            ToDate: value,
                          },
                        })
                      );
                    }}
                    required={true}
                    value={datePickerData?.ToDate}
                    range={false}
                    minDate={
                      datePickerData.FromDate
                        ? new Date(datePickerData.FromDate)
                        : undefined
                    }
                  />
                  {datePickerData.ToDate && (
                    <div
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        top: "11px",
                        right: "35px",
                      }}
                    >
                      <MotifIcon
                        size="24px"
                        onClick={() => {
                          dispatch(
                            setComponentState1({
                              entityName: "reportingTabState",
                              entityState: {
                                ToDate: "",
                              },
                            })
                          );
                        }}
                        src={IconoirXmark}
                      />
                    </div>
                  )}
                </div>
              </MotifFormField>
            </div>
          )}

          {["1", "3", "4", "5", "6"]?.includes(reportId) && (
            <div className="motif-col-md-1 align-self-end">
              <MotifButton
                type="button"
                loading={
                  generateReportFetching || generateReportFetchingWithoutExport
                }
                onClick={generatePayment}
                className="generateReportsBtn"
              >
                {t("pages.reporting.generateReport")}
              </MotifButton>
            </div>
          )}
        </div>
      }
      <br></br>

      {["1", "2"].includes(reportId) ? (
        <>
          {" "}
          <Table
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            columnDefs={columnDefs}
            cellRenderers={tableData && !dataLoading ? tableData : []}
            TitleComplement={() => <></>}
            title="pages.reporting.tableTitle"
            description={
              reportId === "1"
                ? "pages.reporting.tablePaymentRegisterDescription"
                : "pages.reporting.tableDescription"
            }
            caseRenderers={customActionHeader}
            overlayNoRowsTemplate={
              dataLoading
                ? t(tableLoadingData)
                : dataLoadingError
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
            apiData={apiRes}
            apiStatus={apiStatus}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!hasMoreRecords}
            onChangePageSize={(page: number) => {
              setRefreshPaymentRegisterGrid(reportId === "1");

              dispatch(
                setComponentState1({
                  entityName: "reportingTabState",
                  entityState: {
                    PageSize: page,
                    PageNumber: 1,
                  },
                })
              );
            }}
            onChangeNextPage={() => {
              setRefreshPaymentRegisterGrid(reportId === "1");

              dispatch(
                setComponentState1({
                  entityName: "reportingTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber + 1,
                  },
                })
              );
            }}
            onChangePreviousPage={() => {
              setRefreshPaymentRegisterGrid(reportId === "1");

              dispatch(
                setComponentState1({
                  entityName: "reportingTabState",
                  entityState: {
                    PageNumber: paginationObj.PageNumber - 1,
                  },
                })
              );
            }}
            pageSizeSelector={paginationPageSizeSelector}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Reporting;
